module.exports = __webpack_public_path__ + "img/img-26c955.jpg";